import styled from 'styled-components';

export const StateStyled = styled.div`
  align-items: center;
  display: flex;
  gap: 5px;

  > span {
    align-items: center;
    display: flex;
  }
`;
